import { createFileRoute } from "@tanstack/react-router";

import { SendResetPasswordForm } from "@/components/forms/supervisor-send-reset-password-form";
import { Image } from "@/components/image";
import { Link } from "@/components/link";
import { Logo } from "@/components/logo";
import { apiFetch } from "@/lib/api";
import type { ApiEnvelope } from "@/lib/page-data";

const getSupervisorId = async (email: string): Promise<string | null> => {
  try {
    const data = await apiFetch<ApiEnvelope<{ id: string } | null>>(
      `/api/supervisors/lookup?email=${encodeURIComponent(email)}`
    );

    return data?.details?.id ?? null;
  } catch {
    return null;
  }
};

const ResetPasswordPage = () => (
  <div className="container relative hidden min-h-[100dvh] flex-col items-center justify-center md:grid lg:max-w-none lg:grid-cols-2 lg:px-0">
    <div className="relative hidden h-full flex-col bg-muted p-10 text-white dark:border-r lg:flex">
      <div className="absolute inset-0 bg-zinc-900">
        <Image
          src="/img/20170222-OSCAR-Radio-001-scaled.jpg"
          width={1280}
          height={843}
          alt="Authentication"
          className="block h-full object-cover"
        />
      </div>
      <div className="relative z-20 flex items-center text-lg font-medium gap-4">
        <Logo forDirectors={true} />
      </div>
    </div>
    <div className="lg:p-8">
      <div className="mx-auto flex w-full flex-col justify-center space-y-6 sm:w-[350px]">
        <div className="flex flex-col space-y-2 text-center">
          <h1 className="text-2xl font-semibold tracking-tight">
            Reset your password
          </h1>
          <p className="text-sm text-muted-foreground">
            Only supervisors can reset their password this way. If you&apos;re a
            director, contact a supervisor
          </p>
        </div>
        <SendResetPasswordForm getSupervisorId={getSupervisorId} />
        <p className="px-8 text-center text-sm text-muted-foreground">
          If you have any further problems contact a site admin (
          <Link
            href="mailto:oscar-help@7ika.dev "
            className="font-medium cursor-pointer hover:underline hover:underline-offset-4"
          >
            click here
          </Link>
          )
        </p>
      </div>
    </div>
  </div>
);

export const Route = createFileRoute("/supervisors/resetPassword/")({
  component: ResetPasswordPage,
});
